import { createSlice } from "@reduxjs/toolkit";
import { getUnreadThreadCount } from "../thunks/threadThunks";

const initialState = {
  unreadCount: 0,
  loading: false,
  error: null,
};

const threadSlice = createSlice({
  name: "thread",
  initialState,
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    incrementUnreadCount: (state) => {
      state.unreadCount += 1;
    },
    decrementUnreadCount: (state) => {
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUnreadThreadCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUnreadThreadCount.fulfilled, (state, action) => {
        state.loading = false;
        state.unreadCount = action.payload.data.count;
      })
      .addCase(getUnreadThreadCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUnreadCount, incrementUnreadCount, decrementUnreadCount } =
  threadSlice.actions;
export default threadSlice.reducer;
